import { useRouter } from 'next/router';

import { IHome } from '@/modules/home/types';
import { Typography } from '@/shared/components/atoms';
import Badges from '@/shared/components/atoms/Badges';
import { getLocalizedDate } from '@/shared/lib/dates';

const AlertHeader = ({ alert }: { alert: IHome.ITimelineAlertItem }) => {
  const { locale } = useRouter();
  return (
    <>
      {/* task name  */}
      <div className='flex items-center justify-between gap-8 '>
        <Typography variant='subtitle2' weight='semiBold' className=''>
          {alert.incidentReason}
        </Typography>
        <Typography
          variant='caption'
          className=' whitespace-nowrap text-surface-10'
        >
          {getLocalizedDate({
            date: alert.timestamp,
            formatDate: 'hh:mm a',
            locale,
          })}
        </Typography>
      </div>
      {/* task Creator */}
      <div className='flex items-center gap-8'>
        <Typography
          variant='subtitle2'
          weight='medium'
          className='text-surface-10'
        >
          {alert.reporterName}
        </Typography>
        <div className='flex gap-2'>
          <Badges
            className=' border-xs  !border-neutralVariant-90 bg-white '
            badgesList={[
              {
                label: alert.field,
                image: alert.cropImage,
              },
            ]}
            show={1}
            getLabel={(job) => job.label}
            getImage={(job) => job.image}
          />
          <div className='rounded-2xxxxl bg-error-80 px-8 py-5 text-12 font-medium text-tertiary-20'>
            {alert.jobName}
          </div>
        </div>
      </div>
    </>
  );
};
export { AlertHeader };
